import { Component, OnInit, Input } from '@angular/core';
import { PageService } from '../../services/page.service';
import { MultiLangPipe } from '../../pipes/multi-lang.pipe';

interface  LanguageObject {
  languageCode: string;
  value: string;
}

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit {

  @Input() public config: {
    href: Array<LanguageObject> | string,
    // class?: string,
    text?: Array<LanguageObject> | string,
    fill: string,
    size: string,
    expand?: string,
    target: string,
    color?: string
  };
  link;
  class: string = '';
  fill: string = 'clear';
  size: string = 'default';
  expand: string;
  target: string;
  color: string;
  text;
  constructor(
    private pageService: PageService,
    private multiLangPipe: MultiLangPipe
  ) { }

  ngOnInit() {

    let currentLang: string;
    currentLang = this.pageService.appLang$.getValue();


    if (this.config) {

      if (this.config.hasOwnProperty('href') && this.config.href) {
        this.link = this.getValues(this.config.href, currentLang);
      }

      // if (this.config.hasOwnProperty('class') && this.config.class) {
      //   this.class = this.config.class;
      // }

      if (this.config.hasOwnProperty('text') && this.config.text) {
        this.text = this.getValues(this.config.text, currentLang);
      }

      if (this.config.hasOwnProperty('fill') && this.config.fill) {
        this.fill = this.config.fill;
      }

      if (this.config.hasOwnProperty('expand') && this.config.expand) {
        this.expand = this.config.expand;
      }

      if (this.config.hasOwnProperty('size') && this.config.size) {
        this.size = this.config.size;
      }

      if (this.config.hasOwnProperty('color') && this.config.color) {
        this.color = this.config.color;
      }

      if (this.config.hasOwnProperty('target') && this.config.target) {
        this.target = this.config.target;
      }

    }
  }

  /**
   * get link or text for <a> tag
   * @param input [ multilangArray of href or multilangArray of text or href or text ]
   * @param currentLang [ current app language]
   * @author Lalitkumar Saindane
   * @return [string]
   * @task QLIKTAG-3363
   */
  getValues(text, currentLang: string): string {
    let result: any = '';
    if (Array.isArray(text)) {
      result = this.multiLangPipe.transform(text, currentLang);
    } else {
      result = text;
    }
    return result;
  }

}
